// using createAction as backward compatibility, but slice is prefered
import { createAction } from '@reduxjs/toolkit';

import { advancementModuleName } from '@modules/shared/constants';

export const ROUTE_BULK_ENTRY_MB = createAction<{ unitGuid: string }>(
  `${advancementModuleName}/ROUTE_BULK_ENTRY_MB`,
);

export const ROUTE_BULK_ENTRY_ADVENTURE = createAction<{ unitGuid: string }>(
  `${advancementModuleName}/ROUTE_BULK_ENTRY_ADVENTURE`,
);

export const ROUTE_BULK_ENTRY_AWARD = createAction<{ unitGuid: string }>(
  `${advancementModuleName}/ROUTE_BULK_ENTRY_AWARD`,
);

export const ROUTE_BULK_BLUE_CARD = createAction<{ unitGuid: string }>(
  `${advancementModuleName}/ROUTE_BULK_BLUE_CARD`,
);

export const navigateToBulkEntryMB = ROUTE_BULK_ENTRY_MB;
export const navigateToBulkEntryAdventure = ROUTE_BULK_ENTRY_ADVENTURE;
export const navigateToBulkBlueCard = ROUTE_BULK_BLUE_CARD;
export const navigateToBulkAwards = ROUTE_BULK_ENTRY_AWARD;
